export const complaintsList = [
  { label: '3G Turn Off impact', value: '3G Turn Off impact' },
  { label: 'Bereavement Issue', value: 'Bereavement Issue' },
  {
    label: 'Calling International Numbers from UK',
    value: 'Calling International Numbers from UK',
  },
  { label: 'Charge to Mobile', value: 'Charge to Mobile' },
  { label: 'Child Access control', value: 'Child Access control' },
  { label: 'Complaint Handling', value: 'Complaint Handling' },
  { label: 'Data Issues', value: 'Data Issues' },
  {
    label: 'Delay in activating my services',
    value: 'Delay in activating my services',
  },
  { label: 'Device', value: 'Device' },
  { label: 'DPA', value: 'DPA' },
  { label: 'Fraud', value: 'Fraud' },
  {
    label: 'GDPR - Data protection issues',
    value: 'GDPR - Data protection issues',
  },
  {
    label: 'I am unhappy about the arrears process',
    value: 'I am unhappy about the arrears process',
  },
  {
    label: 'I dispute the early termination fee',
    value: 'I dispute the early termination fee',
  },
  {
    label: "I don't understand or agree with charges on my bill",
    value: "I don't understand or agree with charges on my bill",
  },
  { label: 'I have a Handset Fault', value: 'I have a Handset Fault' },
  {
    label: 'I have issues with call quality',
    value: 'I have issues with call quality',
  },
  { label: 'I have no signal', value: 'I have no signal' },
  { label: "I haven't received my bill", value: "I haven't received my bill" },
  { label: "I'm trying to Cancel", value: "I'm trying to Cancel" },
  {
    label: "I'm unable to make/receive a call",
    value: "I'm unable to make/receive a call",
  },
  {
    label: 'Issues with mobile broadband',
    value: 'Issues with mobile broadband',
  },
  {
    label: 'Issues with my roaming service',
    value: 'Issues with my roaming service',
  },
  { label: 'Long Wait times', value: 'Long Wait times' },
  {
    label: 'Missing my promotion/incentive',
    value: 'Missing my promotion/incentive',
  },
  { label: 'Mobile Insurance', value: 'Mobile Insurance' },
  {
    label: 'My contract price/length is incorrect',
    value: 'My contract price/length is incorrect',
  },
  { label: "My delivery hasn't arrived", value: "My delivery hasn't arrived" },
  { label: 'My O2', value: 'My O2' },
  {
    label: "My package isn't as described",
    value: "My package isn't as described",
  },
  {
    label: 'My personal details are incorrect',
    value: 'My personal details are incorrect',
  },
  { label: 'Not included in tariff', value: 'Not included in tariff' },
  { label: 'Nuisance Calls', value: 'Nuisance Calls' },
  { label: 'O2 Marketing', value: 'O2 Marketing' },
  { label: 'Other', value: 'Other' },
  { label: 'Staff Conduct', value: 'Staff Conduct' },
  {
    label: "There's a problem with my payment",
    value: "There's a problem with my payment",
  },
  { label: 'Trouble Porting my number', value: 'Trouble Porting my number' },
  {
    label: 'Unable to place an order online',
    value: 'Unable to place an order online',
  },
  {
    label: 'Unhappy with the offers available',
    value: 'Unhappy with the offers available',
  },
  { label: 'Unwanted emails', value: 'Unwanted emails' },
  { label: 'Unwanted Sale', value: 'Unwanted Sale' },
  { label: 'Volt', value: 'Volt' },
];
